import { v4 as uuidv4 } from 'uuid';
import { NavigationSession } from '../../types/navigation-tracking';

const SESSION_KEY = 'futuregen_session';
const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

export class SessionManager {
  private session: NavigationSession | null = null;

  constructor() {
    this.loadSession();
  }

  getSessionId(): string {
    if (!this.session || this.isExpired()) {
      this.createSession();
    }
    this.touch();
    return this.session!.sessionId;
  }

  reset(): void {
    this.session = null;
    try {
      localStorage.removeItem(SESSION_KEY);
    } catch {
      // localStorage unavailable
    }
  }

  private loadSession(): void {
    try {
      const stored = localStorage.getItem(SESSION_KEY);
      if (stored) {
        this.session = JSON.parse(stored);
      }
    } catch {
      // localStorage unavailable or corrupt
    }
  }

  private createSession(): void {
    this.session = {
      sessionId: uuidv4(),
      startedAt: new Date().toISOString(),
      lastActivityAt: new Date().toISOString(),
    };
    this.persist();
  }

  private isExpired(): boolean {
    if (!this.session) return true;
    const lastActivity = new Date(this.session.lastActivityAt).getTime();
    return Date.now() - lastActivity > SESSION_TIMEOUT_MS;
  }

  private touch(): void {
    if (this.session) {
      this.session.lastActivityAt = new Date().toISOString();
      this.persist();
    }
  }

  private persist(): void {
    try {
      localStorage.setItem(SESSION_KEY, JSON.stringify(this.session));
    } catch {
      // localStorage full or unavailable
    }
  }
}
